import { Injectable } from '@angular/core';
import { DiscountEntity } from '@core/store/entities/discount/discount.entity';
import { DiscountUtils } from '@entities/discount/discount.selectors';

@Injectable({
  providedIn: 'root',
})
export class DiscountNameHelper {
  helpDiscountName(discount: DiscountEntity): DiscountEntity {
    for (const replacement of DiscountUtils.NAME_REPLACEMENTS) {
      if (discount.description === replacement[0]) {
        return {
          ...discount,
          description: replacement[1],
        };
      }
    }
    return discount;
  }
}
